import React from "react";
import { spring, useCurrentFrame, useVideoConfig } from "remotion";

type StackChipProps = {
  text: string;
  color?: string;
  enterFrame?: number;
  fontSize?: number;
};

// Remotion-side version of atoms/customButton — pops in with a spring when
// enterFrame is provided, otherwise renders statically.
const StackChip: React.FC<StackChipProps> = ({
  text,
  color = "#fcaeea",
  enterFrame,
  fontSize = 22,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const pop =
    enterFrame === undefined
      ? 1
      : spring({
          frame: frame - enterFrame,
          fps,
          config: { damping: 14, stiffness: 160, mass: 0.6 },
        });

  return (
    <div
      style={{
        color: "white",
        border: `3px solid ${color}`,
        borderRadius: 18,
        width: "max-content",
        padding: "6px 16px",
        margin: 6,
        fontSize,
        fontFamily: "Montserrat, sans-serif",
        scale: String(pop),
        opacity: pop,
        backgroundColor: "rgba(0, 0, 0, 0.35)",
      }}
    >
      {text}
    </div>
  );
};

export default StackChip;
